import { render, staticRenderFns } from "./CarrierInformation.vue?vue&type=template&id=37aef9e8"
import script from "./CarrierInformation.vue?vue&type=script&lang=js"
export * from "./CarrierInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports